module.exports = __webpack_public_path__ + "static/media/news_header1.0b92283f.png";